import ProductModalWithButton from "./ProductModalWithButton";

function OptionalProductItem({
  handleSwitchChange,
  isChosen,
  productDescription,
  productId,
  productName,
}) {
  return (
    <div className="ps-4">
      <div className="form-check form-switch mb-3">
        <input
          className={`form-check-input fs-4 ${isChosen ? "active" : ""}`}
          type="checkbox"
          role="switch"
          id={`flexSwitchCheck${productId}`}
          onChange={handleSwitchChange}
          value={productId}
          checked={isChosen}
        />
        <label
          className={`form-check-label d-block product lh-1 py-2 px-2 optional ${
            isChosen ? "active" : ""
          }`}
          htmlFor={`flexSwitchCheck${productId}`}
        >
          {productName}
          <ProductModalWithButton
            productId={productId}
            productDescription={productDescription}
            productName={productName}
          />
        </label>
      </div>
    </div>
  );
}

export default OptionalProductItem;
